// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27YTL","icon":"styles_icon__1K_Eg"};